/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An admin adds a member from the register to an event.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto {
    /**
     * The event to add the member to.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto
     */
    eventId?: number;
    /**
     * The member in the register.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto
     */
    memberId?: number;
    /**
     * The times the member takes part in. A fully booked time puts the member on the waitlist.
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto
     */
    timeIds?: Array<number> | null;
    /**
     * Note from the admin, saved as the message of the reply.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto
     */
    note?: string | null;
    /**
     * True to send a confirmation to the member. Ignored when the member has no e-mail.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto
     */
    sendConfirmation?: boolean;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto {
    return WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'timeIds': !exists(json, 'timeIds') ? undefined : json['timeIds'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'sendConfirmation': !exists(json, 'sendConfirmation') ? undefined : json['sendConfirmation'],
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'memberId': value.memberId,
        'timeIds': value.timeIds,
        'note': value.note,
        'sendConfirmation': value.sendConfirmation,
    };
}

